const LOG_PREFIX = "[OCM][PageSense] "
let pageSense = async (utils) => {
  return new Promise((resolve, reject) => {
    let pageType = 'ROS';
    let subPaths = window.location.pathname.replace("/", "").split("/") || [];
    let customPaths = ['about','epikoinonia','contributors','diafimisi','oroi-hrisis','politiki-aporritou'];
    let specialPaths = ['se-eida','covers','zodia','your-voice','radio','stiles','issues'];

    // Keep only String values in subPaths (removes null and empty)
    subPaths = subPaths.filter(String);
    // The actual page sense goes here
    if (subPaths.length === 0) {
      pageType = "Home";
    } else if (subPaths.length < 4) {
      if (customPaths.indexOf(subPaths[0]) >= 0) {
        pageType = "Custom-1";
      } else if (specialPaths.indexOf(subPaths[0]) >= 0) {
        pageType = "Special-Category";
      } else if (subPaths[0] === "tags") {
        pageType = "Tag";
      }else {
        pageType = "Category";
      }
    } else {
      pageType = "Article";
    }

    utils.loadStyle('.teads-player.smart-position-corner {left:5px !important; right: revert !important}')

    resolve(pageType)
  });
};
module.exports = pageSense;